var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',{staticClass:"inline-block custom-tag"},[_c('el-tag',{attrs:{"size":"mini","type":_vm.value}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }